import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import AppColors from "../Utils/AppColor";
import "./styles.css";
import { Box, Typography } from "@mui/material";

export interface CommonDataGridProps {
  tableResponse: {
    message: string;
    type: string;
    tableHeaders: { field: string; headerName: string }[];
    tableRowData: { [key: string]: any }[];
  };
}

export const getRowClassName = (params: any) => {
  return params.indexRelativeToCurrentPage % 2 === 0 ? "even-row" : "odd-row";
};

const CommonDataGrid: React.FC<CommonDataGridProps> = ({ tableResponse }) => {
  console.log("tableResponse", tableResponse);

  const { tableHeaders, tableRowData } = tableResponse;

  const updatedColumns = tableHeaders?.map((col) => ({
    ...col,
    flex: 0.5, // Add default flex if width is not specified
  }));

  // Map rows to include an id (you can customize this further if needed)
  const rows = tableRowData?.map((row, index) => ({
    id: index, // Use index as the unique id for the row
    ...row,
  }));

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        boxShadow: 8,
        borderRadius: 2,
      }}
    >
      <DataGrid
        rows={rows}
        getRowClassName={getRowClassName}
        disableAutosize
        disableRowSelectionOnClick
        disableColumnResize
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        disableColumnSorting
        disableColumnMenu
        hideFooterPagination
        sx={{
          backgroundColor: AppColors.appWhite,
        }}
        columns={updatedColumns}
      />
    </Box>
  );
};

export default CommonDataGrid;
